"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Chevron = (props) => {
    return (react_1.default.createElement("svg", { className: "chevron", xmlns: "http:www.w3.org/2000/svg", viewBox: "0 0 448 512", width: "15", height: "45", style: {
            width: '15px',
            color: ' #007EFF',
            height: '45px',
            transform: `${props.rotate ? 'rotate(180deg)' : 'rotate(0deg)'}`,
        } },
        react_1.default.createElement("path", { fill: "#007eff", d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z" })));
};
exports.default = Chevron;
